import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { RECORD_STATUS_VALUES, TABLE_OPTION_VALUES } from '../../shared/constants/api-constants';
import { ColumnManageComponent } from '../../shared/popover/column-manage/column-manage.component';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-inventory-itinerary-grid-view',
  templateUrl: './inventory-itinerary-grid-view.component.html',
  styleUrls: ['./inventory-itinerary-grid-view.component.scss'],
})
export class InventoryItineraryGridViewComponent implements OnInit {

  @Input() allData: any
  @Input() data: any;;

  @Input() hidePaginations: boolean = false;
  paginationSettings: any;
  visiblePages: number[] = [];
  noOfRows: any = 0;
  @Output() triggerDeleteRow = new EventEmitter<void>();
  @Output() triggerEditRow = new EventEmitter<void>();
  @Output() triggerViewRow = new EventEmitter<void>();
  @Output() triggerAuditRow = new EventEmitter<void>();

  @Input() columns: any = [];
  @Input() showColumnSelector: boolean = true;
  initialColumns: any = [];

  @Input() hideExtraColumns: boolean = false;

  @Output() paginationsUpdated = new EventEmitter<void>();
  @Output() manageColumnsChange = new EventEmitter<any>();

  // Multi select related variables
  selectedRowIds: any[] = [];
  @Input() multiSelectProperty: string | null = null;

  inventoryItineraryStatusLov: any = [
    {
      key: RECORD_STATUS_VALUES.PENDING,
      name: RECORD_STATUS_VALUES.PENDING
    },
    {
      key: RECORD_STATUS_VALUES.APPROVED,
      name: RECORD_STATUS_VALUES.APPROVED
    }
  ]

  itineraryTypeLov: any = [
    { key: 'domestic', name: 'Domestic' },
    { key: 'international', name: 'International' }
  ]

  constructor(
    private _popoverController: PopoverController,
    private _inventoryService: InventoryService,
    private _reloadService: ComponentReloadService,
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService,
    private _lovDataService: LovDataService,
    private _responseNotificationService: ResponseNotificationService
  ) { }

  ngOnInit() {
    this.initialColumns = this.getVisibleColumns(this.columns);
  }

  ngOnChanges() {
    this.data = this.allData.data;

    this.paginationSettings = this.allData;

    if (this.data && this.data.length) {
      delete this.paginationSettings.data;
      this.noOfRows = this.data.length;
      this.updateVisiblePages();
    }

    if (this.data && this.data.length === 0) {
      this.hidePaginations = true;
    } else {
      this.hidePaginations = false;
    }
  }

  async openPassengerOptionPopover(event: any, row: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            {
              value: "View",
              path: TABLE_OPTION_VALUES.VIEW
            },
            {
              value: "Edit",
              path: TABLE_OPTION_VALUES.EDIT
            },
            {
              value: "Audit History",
              path: TABLE_OPTION_VALUES.SHOW_AUDIT
            },
            {
              value: "Delete",
              path: TABLE_OPTION_VALUES.DELETE
            }
          ]
        },
        onPathSelected: (data: any) => this.onPassengerActionOptionSelected(data, row)
      }
    });
    return await popover.present()
  }


  onPassengerActionOptionSelected(data: any, row: any) {
    this._popoverController.dismiss();
    switch (data.path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.triggerDeleteRow.emit(row.itineraryId);
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.triggerEditRow.emit(row.itineraryId);
        break;
      }
      case TABLE_OPTION_VALUES.VIEW: {
        this.triggerViewRow.emit(row.itineraryId);
        break;
      }
      case TABLE_OPTION_VALUES.SHOW_AUDIT: {
        this.triggerAuditRow.emit(row.itineraryId);
        break;
      }
    }

  }

  // Manage columns

  async openColumnOptions(ev: any) {
    const columnPopOver = await this._popoverController.create({
      component: ColumnManageComponent,
      event: ev,
      componentProps: { columns: this.cloneVariable(this.columns) },
      cssClass: "popup-component"
    })
    await columnPopOver.present();
    const { data } = await columnPopOver.onDidDismiss();
    if (data) {
      this.columns = data;
      this.initialColumns = data.filter((column: { showColumn: any; }) => column.showColumn);
      this.manageColumnsChange.emit(data);
    } else {
      this.resetColumn();
      this.ngOnInit();
    }
  }

  resetColumn() {
    this.initialColumns = this.columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  getVisibleColumns(columns: any) {
    return columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  shouldShowColumn(colKey: any): boolean {
    return this.initialColumns.some((column: any) => column.key === colKey && column.showColumn);
  }

  getfullColSpan() {
    let colspan = this.initialColumns.length
    if (this.showColumnSelector) {
      colspan = colspan + 1;
    }
    colspan = colspan + 1;
    return colspan;
  }

  cloneVariable(variable: any) {
    return JSON.parse(JSON.stringify(variable));
  }

  // Multi select variables

  // Check if all rows are selected
  isAllSelected(): boolean {
    if (!this.data || !this.multiSelectProperty) return false;
    return this.data.length > 0 && this.selectedRowIds.length === this.data.length;
  }

  // Toggle all rows
  toggleSelectAllRows(event: any) {
    if (event.target.checked) {
      this.selectedRowIds = this.data.map((row: any) => row[this.multiSelectProperty as string]);
    } else {
      this.selectedRowIds = [];
    }
  }

  // Toggle single row
  toggleSelectRow(event: any, row: any) {
    const id = row[this.multiSelectProperty as string];
    if (event.target.checked) {
      if (!this.selectedRowIds.includes(id)) {
        this.selectedRowIds.push(id);
      }
    } else {
      this.selectedRowIds = this.selectedRowIds.filter(selectedId => selectedId !== id);
    }
  }

  // Utility to check if a row is selected
  isRowSelected(row: any): boolean {
    return this.selectedRowIds.includes(row[this.multiSelectProperty as string]);
  }

  getSelectedRows(): any[] {
    if (!this.data || !this.multiSelectProperty) {
      return [];
    }
    // Only return selected rows that are present in the current page's data
    const selectedRows = this.data.filter((row: any) =>
      this.selectedRowIds.includes(row[this.multiSelectProperty as string])
    );
    return selectedRows;
  }

  areRowsSelected(): boolean {
    if (this.selectedRowIds && this.selectedRowIds.length > 0) {
      return true;
    }
    return false;
  }

  // Paginations
  updateVisiblePages() {
    const currentPage = this.paginationSettings.pageNumber;
    const totalPages = this.paginationSettings.totalPages;

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    this.visiblePages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
  }

  onPageChange(page: number) {
    if (page !== this.paginationSettings.pageNumber) {
      this.paginationSettings.pageNumber = page;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onNext() {
    if (this.paginationSettings.pageNumber < this.paginationSettings.totalPages) {
      this.paginationSettings.pageNumber++;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPrevious() {
    if (this.paginationSettings.pageNumber > 1) {
      this.paginationSettings.pageNumber--;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPageSizeChange() {
    this.paginationSettings.pageNumber = 1;
    this.updateVisiblePages();
    this.loadPageData();
  }

  loadPageData() {
    this.paginationsUpdated.emit(this.paginationSettings);
  }

  // Cell actions

  openItineraryView(row: any) {
    this.triggerViewRow.emit(row.itineraryId);
  }

  statusChanged(event: any, row: any) {
    let inventoryItinerary: any;
    let inventoryId = row.itineraryId;
    this._inventoryService.getInventoryItinerary(inventoryId).subscribe((data) => {
      inventoryItinerary = data;
      inventoryItinerary.itineraryDetails.status = event.target.value;
      this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe((data) => {
        this._reloadService.triggerInventoryItineraryReload();
      })
    })
  }

  showInWebsiteChanged(event: any, row: any) {
    const inventoryId = row.itineraryId;
    const value = event.target.checked;

    this._inventoryService.getInventoryItinerary(inventoryId).subscribe((inventoryItinerary) => {
      const details = inventoryItinerary.itineraryDetails;

      if (!details.approxCost?.amount) {
        this._globalService.customAlert("Please set Approx Cost before setting Show In Website");
      } else if (!details.imagePath) {
        this._globalService.customAlert("Please set a Banner Image before setting Show In Website");
      } else if (!details.itineraryType) {
        this._globalService.customAlert("Please set Itinerary Type before setting Show In Website");
      } else {
        details.showInWebsite = value;
        this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe(() => {
          this._reloadService.triggerInventoryItineraryReload();
        });
        return;
      }

      this._reloadService.triggerInventoryItineraryReload();
    });
  }

  onCostChanged(value: any, row: any) {
    if (!value || !value?.amount) {
      return;
    }
    const inventoryId = row.itineraryId;
    this._inventoryService.getInventoryItinerary(inventoryId).subscribe((inventoryItinerary) => {
      const details = inventoryItinerary.itineraryDetails;
      details.approxCost = value;
      this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe(() => {
        this._reloadService.triggerInventoryItineraryReload();
      });
    });
  }

  viewBannerImage(row: any) {
    this._modalPopupService.openImageModal(row.imagePath);
  }

  uploadBannerImage(row: any) {
    const inventoryId = row.itineraryId;
    // Create a hidden file input dynamically
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*'; // restrict to images
    fileInput.style.display = 'none';

    // When user selects a file
    fileInput.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (file) {
        console.log('Selected file:', file);
        if (file.size > 5 * 1024 * 1024) {
          this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
          return;
        }

        if (file) {
          const formData = new FormData();
          formData.append('image', file);
          this._lovDataService.uploadImage(formData, "website").subscribe({
            next: (res) => {
              this._inventoryService.getInventoryItinerary(inventoryId).subscribe((inventoryItinerary) => {
                const details = inventoryItinerary.itineraryDetails;
                details.imagePath = res;
                this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe(() => {
                  this._reloadService.triggerInventoryItineraryReload();
                });
              });
            },
            error: (error) => {
              console.error('Error uploading image: ', error);
              this._responseNotificationService.showMessage("Error uploading image", true);
            }
          })
        }
      }
    };

    // Trigger the file input click
    fileInput.click();
  }

  itineraryTypeChanged(event: any, row: any) {
    let inventoryItinerary: any;
    let inventoryId = row.itineraryId;
    let value = event.target.value;
    this._inventoryService.getInventoryItinerary(inventoryId).subscribe((data) => {
      inventoryItinerary = data;
      inventoryItinerary.itineraryDetails.itineraryType = value;
      this._inventoryService.updateInventoryItinerary(inventoryId, inventoryItinerary).subscribe((data) => {
        this._reloadService.triggerInventoryItineraryReload();
      })
    });
  }

}
